export default __webpack_public_path__ + "static/media/logout.4f41b6b6.svg";